import { reactive } from 'vue'
import * as Cesium from 'cesium'

export const cesiumMapType = reactive({
  // 地图类型切换控件
  mapType: '3D', // 默认3D模式
  twoDModel: true,
  threeModel: false,
  // 地图类型列表
  mapTypes:
    {
      '2D': Cesium.SceneMode.SCENE2D,
      '3D': Cesium.SceneMode.SCENE3D
    }

})

/** 地图模式名称 */
export const MapTypeName:{[x:number]:string} = {
  [Cesium.SceneMode.SCENE2D]: '3D',
  [Cesium.SceneMode.SCENE3D]: '2D'
}
